import { Badge } from '@windmill/react-ui';
import { FunctionComponent } from 'react';

import { AppStatus } from '../../common/enums';

const getBadgeTypeByAppStatus = (status: string) => {
  switch (status) {
    case 'REJECTED':
      return 'danger';
    case 'DEVELOPMENT':
    case 'IN-REVIEW':
      return 'warning';
    case 'APPROVED':
    case 'LIVE':
      return 'success';
    case 'DEPRECATED':
    default:
      return 'neutral';
  }
};
export const AppStatusBadge: FunctionComponent<{ status: AppStatus }> = ({
  status,
}) => {
  return (
    <Badge className="mb-px" type={`${getBadgeTypeByAppStatus(status)}`}>
      {status}
    </Badge>
  );
};
